var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLikeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: " transition-transform duration-300 group-hover:rotate-12 group-hover:scale-125",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M6.535 14.609a0.2 0.2 0 0 1 -0.003 0.041 0.705 0.705 0 0 1 -0.7 0.663h-1.6a0.707 0.707 0 0 1 -0.703 -0.703V7.922a0.707 0.707 0 0 1 0.703 -0.703h1.6a0.704 0.704 0 0 1 0.703 0.703zm8.959 -3.3a1.169 1.169 0 0 1 -0.463 1.85 1.164 1.164 0 0 1 -0.869 1.922h-5.744c-0.487 -0.015 -1.097 -0.128 -1.415 -0.472v-6.55a3.133 3.133 0 0 1 0.565 -0.394 3.393 3.393 0 0 0 1.737 -3.025V3.119a0.927 0.927 0 0 1 1.25 -0.872c0.859 0.325 1.741 1.341 1.063 4.335l-0.097 0.35a0.229 0.229 0 0 0 0.222 0.287h3.519a1.163 1.163 0 0 1 0.619 2.169 1.163 1.163 0 0 1 -0.387 1.922"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/like_icon.98ff9343f3a2ecae6e00770f01cd452d.svg";
export { ForwardRef as ReactComponent };